import chinese from './languages/chinese';
import czech from './languages/czech';
import english from './languages/english';
import french from './languages/french';
import germanat from './languages/germanat';
import indonesian from './languages/indonesian';
import polish from './languages/polish';
import romanian from './languages/romanian';
import spanish from './languages/spanish';
import spanishmx from './languages/spanishmx';
import thai from './languages/thai';
import turkish from './languages/turkish';
import usenglish from './languages/us-english';

const languageTranslate = (languageCode) => {
	let lang = english;
	switch (languageCode) {
		case 'tr-TR':
			lang = turkish;
			break;
		case 'zh-CN':
			lang = chinese;
			break;
		case 'fr-FR':
			lang = french;
			break;
		case 'fr':
			lang = french;
			break;
		case 'id':
			lang = indonesian;
			break;
		case 'th':
			lang = thai;
			break;
		case 'en-US':
			lang = usenglish;
			break;
		case 'cs':
			lang = czech;
			break;
		case 'ro':
			lang = romanian;
			break;
		case 'de':
			lang = germanat;
			break;
		case 'pl':
			lang = polish;
			break;
		case 'es':
			lang = spanish;
			break;
		case 'es-MX':
			lang = spanishmx;
			break;
		default:
			lang = english;
			break;
	}

	const localString = (string) => {
		let conversionArr = JSON.parse(sessionStorage.getItem('conversion')) || [];
		if (lang && lang[string]) {
			if (conversionArr.indexOf(string) > -1) {
				conversionArr.splice(conversionArr.indexOf(string), 1);
			}
			sessionStorage.setItem('conversion', JSON.stringify(conversionArr));
			return lang[string].text;
		} else {
			if (string) {
				if (conversionArr && conversionArr.length > 0) {
					if (conversionArr.indexOf(string) < 0) {
						conversionArr.push(string);
						sessionStorage.setItem('conversion', JSON.stringify(conversionArr));
					}
				}
				else {
					conversionArr.push(string);
					sessionStorage.setItem('conversion', JSON.stringify(conversionArr));
				}
			}
			return string
		}
	};
	return localString;
}
export default languageTranslate;
